<template>
  <div :class="['drop-search-result', mod, {'_loader': !isSearchResult}]">
    <div class="drop-search-result__content-wrapper" :style="`height: ${contentWrapperHeight}`">
      <div class="drop-search-result__content">
        <clarifications-block
          v-if="isSearchHints"
          :with-title="false"
          :taps-list="searchHints"
          class="drop-search-result__hints"
          :hide-decorator-on-mobile="true"
          @setQuery="onSetQuery"
        />
        <search-history
          v-if="isViewHistory"
          :items="localStorageHistory"
          class="drop-search-result__history"
          @clearHistory="deleteHistory"
          @setItem="onSetQuery"
          @deleteItem="deleteItem"
        />
        <search-items-popular
          v-if="isSearchPopular"
          :items="searchPopular"
          class="drop-search-result__popular"
          @setQuery="onSetQuery"
        />
        <search-items-categories
          v-if="isSearchCategories"
          :items="searchCategories"
          class="drop-search-result__categories"
        />
        <search-items-result
          v-if="isSearchResult"
          :items="data.products"
          class="drop-search-result__result"
        />
        <span v-else-if="hasdata" class="no-result-text">По вашему запросу ничего не найдено</span>
      </div>
    </div>
    <button
      v-if="showAllResultsButton"
      class="show-more-button"
      :disabled="!searchStringIsNotEmpty"
      @click="showMoreButtonHandler"
    >
      <span>Смотреть все результаты</span>
    </button>
  </div>
</template>

<script>
import SearchHistory from './SearchHistory.vue';
import SearchItemsResult from './SearchItemsResult.vue';
import SearchItemsCategories from './SearchItemsCategories.vue';
import SearchItemsPopular from './SearchItemsPopular.vue';
import ClarificationsBlock from '../../../vue-search-page/components/heplers/ClarificationsBlock.vue';

export default {
  name: 'drop-search-result',

  components: {
    SearchHistory,
    SearchItemsResult,
    SearchItemsCategories,
    SearchItemsPopular,
    ClarificationsBlock,
  },

  props: {
    mod: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
    searchString: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    newLocalStorageHistory: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      localStorageHistory: [],
    };
  },

  computed: {
    isViewHistory() {
      return this.localStorageHistory.length && this.isSearchResult;
    },

    isSearchHints() {
      return ('taps' in this.data) && this.data.taps.length;
    },

    isSearchPopular() {
      return ('sts' in this.data) && this.data.sts.length;
    },

    isSearchResult() {
      return ('products' in this.data);
    },

    isSearchCategories() {
      return ('categories' in this.data) && this.data.categories.length;
    },

    hasdata() {
      return !!Object.keys(this.data).length;
    },

    searchCategories() {
      return this.isSearchCategories ? this.data.categories.slice(0, 3) : [];
    },

    searchHints() {
      return this.isSearchHints ? this.data.taps : [];
    },

    searchPopular() {
      return this.isSearchPopular ? this.data.sts.slice(0, 3) : [];
    },

    searchStringIsNotEmpty() {
      return this.searchString.length > 0;
    },

    showAllResultsButton() {
      if (this.isMobile) return true;
      return this.searchStringIsNotEmpty;
    },

    contentWrapperHeight() {
      if (window.innerWidth < 951) return 'calc(100% - 50px)';
      if (!this.isSearchResult && this.hasdata) return 'auto';
      const VERTICAL_MARGINS = 105;
      const MAX_HEIGHT = 690;
      return window.innerHeight - VERTICAL_MARGINS > MAX_HEIGHT ? '690px' : `${window.innerHeight - VERTICAL_MARGINS}px`;
    },
  },

  watch: {
    isSearchResult(newValue) {
      if (newValue) window.loaderHide('.drop-search-result__content');
    },
    newLocalStorageHistory(newValue) {
      if (newValue) this.setLocalStorageHistory(newValue);
    },
  },

  mounted() {
    if (!this.isSearchResult) window.loaderShow('.drop-search-result__content');
    const localHistorydata = JSON.parse(localStorage.getItem('search-history'));
    if (localHistorydata) this.localStorageHistory = localHistorydata;
  },

  methods: {
    onSetQuery(query) {
      this.$emit('setQuery', query);
      this.setLocalStorageHistory(query);
    },

    setLocalStorageHistory(value) {
      const lsHistory = localStorage.getItem('search-history');

      if (!lsHistory) {
        const data = [{ value }];
        localStorage.setItem('search-history', JSON.stringify(data));
        this.localStorageHistory = data;
        return;
      }

      const data = JSON.parse(lsHistory);
      if (data.find((item) => item.value === value)) return;

      data.push({ value });
      localStorage.setItem('search-history', JSON.stringify(data));
      this.localStorageHistory = data;
    },

    deleteHistory() {
      this.localStorageHistory = [];
    },

    deleteItem(value) {
      const data = JSON.parse(localStorage.getItem('search-history'));
      const itemInd = data.findIndex((item) => item.value === value);
      if (itemInd !== -1) {
        data.splice(itemInd, 1);
        localStorage.setItem('search-history', JSON.stringify(data));
        this.localStorageHistory.splice(itemInd, 1);
      }
    },

    showMoreButtonHandler() {
      window.location.href = `${window.location.origin}/search/?query=${this.searchString}`;
    },
  },

};
</script>

<style lang="scss" scoped>
.drop-search-result {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transform: translateY(-100%);
  z-index: 20;
  border-radius: 4px;
  opacity: 0;
  visibility: hidden;
  transition: transform 0.1s 0.7s, opacity 0.7s, visibility 0.7s;
  background-color: rgba(51, 51, 50, 0.5);
  overflow-y: scroll;
  scrollbar-width: none;
  box-shadow: 0 4px 16px 0 rgba(51, 51, 51, 0.14);
  z-index: 102;
  @media (max-width: 950px) {
    position: fixed;
    top: 40px;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar {
    width: 0;
  }

  &._open {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
    transition: opacity 0.7s, visibility 0.7s;

    & .drop-search-result__content-wrapper {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
    }
    & .drop-search-result__content {
      overflow: auto;
    }
  }

  &._loader {
    min-height: 200px;
    & .drop-search-result__content-wrapper {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
      height: 100%;
      text-align: center;
      @media (max-width: 950px) {
        height: calc(100% - 50px);
      }
    }
  }

  &__content {
    height: 100%;
    padding-right: 16px;
    overflow: auto;
  }

  &__content-wrapper {
    padding: 60px 0 16px 16px;
    position: relative;
    background-color: #fff;
    opacity: 0;
    visibility: hidden;
    overflow: hidden;
    transition: transform 0.7s, opacity 0.7s, visibility 0.7s;

    @media (max-width: 1024px) {
      padding-bottom: 0;
    }

    @media (max-width: 950px) {
      padding-top: 72px;

      &::after {
        content: '';
        position: absolute;
        top: 60px;
        right: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: #e5e5e5;
      }
    }
  }

  &__hints,
  &__history,
  &__popular,
  &__categories {
    margin-bottom: 16px;
  }

  .no-result-text {
    display: block;
    margin: 0;
    padding: 25px 0;
    font-size: 18px;
  }

  .show-more-button {
    position: relative;
    z-index: 100;
    width: 100%;
    height: 50px;
    background-color: #e30613;
    padding: 16px 10px;
    transition: background .2s;
    &:disabled {
      background-color: #808080;
    }

    & span {
      position: relative;
      font-size: 16px;
      line-height: 21px;
      font-weight: 600;
      letter-spacing: 0.03em;
      color: #FFFFFF;

      &::after {
        content: '';
        position: absolute;
        top: 6px;
        right: -15px;
        width: 9px;
        height: 9px;
        border-top: 2px solid #FFFFFF;
        border-right: 2px solid #FFFFFF;
        transform: rotate(45deg);
      }
    }
  }
}
</style>

<style lang="scss">
.drop-search-result {
  &._loader {
    & .loader-container {
      top: calc(50% - 48px);
      left: calc(50% - 48px);
      margin: 0;
    }
  }
}
</style>
